document.addEventListener("DOMContentLoaded", function () {
  // Function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Function to animate number counting
  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);

      // Handle numbers with decimal points and percentages
      if (String(end).includes("%")) {
        const numericEnd = parseFloat(end);
        obj.innerHTML = Math.floor(progress * numericEnd) + "%";
      } else if (String(end).includes(".")) {
        const numericEnd = parseFloat(end);
        obj.innerHTML = (progress * numericEnd).toFixed(1);
      } else {
        obj.innerHTML = Math.floor(progress * end);
      }

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  // Get all stat values
  const statValues = document.querySelectorAll(".text__stats-value");
  let animated = false;

  // Function to start animation when in viewport
  function checkAndAnimate() {
    if (
      !animated &&
      isInViewport(document.getElementById("daily-stats-section"))
    ) {
      statValues.forEach(function (statValue) {
        const finalValue = statValue.getAttribute("data-value");
        const duration =
          parseInt(statValue.getAttribute("data-animation-duration")) || 1500;
        animateValue(statValue, 0, finalValue, duration);
      });
      animated = true;
      // Remove scroll listener once animated
      window.removeEventListener("scroll", checkAndAnimate);
    }
  }

  // Check on page load and scroll
  checkAndAnimate();
  window.addEventListener("scroll", checkAndAnimate);
});
